import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Container, Row, Col } from "react-bootstrap";
import { FaUserShield, FaLock, FaCookieBite, FaEnvelope } from "react-icons/fa";

import Navr from "../Navbar/Navr";
import Footer from "./Footer";

export default function Privacy() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo(0, 0); // Page load hone par top par layega
  }, []);

  return (
    <div className="privacy-page">
      <Navr />

      {/* --- Header Section --- */}
      <div className="privacy-header text-center py-5">
        <Container>
          <div data-aos="fade-down">
             <FaUserShield className="text-danger display-3 mb-3" />
             <h1 className="fw-bold text-dark">Privacy Policy</h1>
             <p className="text-muted">Last Updated: October 2023</p>
             <div className="separator mx-auto"></div>
          </div>
        </Container>
      </div>

      {/* --- Content Section --- */}
      <section className="py-5 bg-white">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="policy-content" data-aos="fade-up">
                
                <p className="lead text-dark mb-5 text-center">
                  At <strong>Jawali Holidays</strong>, we are committed to protecting your personal information. 
                  This Privacy Policy explains how we collect, use, and safeguard your data when you book a trip with us.
                </p>

                {/* Policy Point 1 */}
                <div className="policy-item mb-5">
                  <h4 className="fw-bold text-danger d-flex align-items-center">
                    <span className="icon-circle me-3">1</span> Information We Collect
                  </h4>
                  <p className="text-muted">
                    We collect information required to provide travel services, including but not limited to:
                  </p>
                  <ul className="text-muted">
                    <li><strong>Personal Details:</strong> Name, age, gender, address.</li>
                    <li><strong>Contact Info:</strong> Phone number, email address.</li>
                    <li><strong>Travel Documents:</strong> Passport details, Aadhar card (for bookings).</li>
                    <li><strong>Payment Data:</strong> Credit/Debit card details (processed securely via gateways).</li>
                  </ul>
                </div>

                {/* Policy Point 2 */}
                <div className="policy-item mb-5">
                  <h4 className="fw-bold text-danger d-flex align-items-center">
                    <span className="icon-circle me-3">2</span> How We Use Your Data
                  </h4>
                  <p className="text-muted">
                    Your data is used strictly for legitimate business purposes:
                  </p>
                  <ul className="text-muted">
                    <li>To process flight, hotel, and train bookings.</li>
                    <li>To send booking confirmations and travel updates.</li>
                    <li>To assist with visa applications and travel insurance.</li>
                    <li>To improve our website experience and customer support.</li>
                  </ul>
                </div>

                {/* Policy Point 3 */}
                <div className="policy-item mb-5">
                  <h4 className="fw-bold text-danger d-flex align-items-center">
                    <span className="icon-circle me-3">3</span> Data Sharing & Third Parties
                  </h4>
                  <p className="text-muted">
                    We do <strong>not</strong> sell your data. However, we must share necessary details with:
                  </p>
                  <ul className="text-muted">
                    <li><strong>Service Providers:</strong> Airlines, Hotels, Transport agencies (to fulfill bookings).</li>
                    <li><strong>Legal Authorities:</strong> If required by law or government regulations.</li>
                  </ul>
                </div>

                {/* Policy Point 4 */}
                <div className="policy-item mb-5">
                  <h4 className="fw-bold text-danger d-flex align-items-center">
                    <span className="icon-circle me-3"><FaLock size={16}/></span> Security of Data
                  </h4>
                  <p className="text-muted">
                    We implement industry-standard security measures (SSL encryption, secure servers) to protect your personal information from unauthorized access, alteration, or disclosure.
                  </p>
                </div>

                {/* Policy Point 5 */}
                <div className="policy-item mb-5">
                  <h4 className="fw-bold text-danger d-flex align-items-center">
                    <span className="icon-circle me-3"><FaCookieBite size={16}/></span> Cookies Policy
                  </h4>
                  <p className="text-muted">
                    Our website uses cookies to enhance user experience. Cookies help us remember your preferences and analyze website traffic. You can choose to disable cookies in your browser settings.
                  </p>
                </div>

              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- Contact for Privacy --- */}
      <section className="py-5 bg-light text-center">
        <Container>
           <h4 className="fw-bold mb-3">Have Privacy Concerns?</h4>
           <p className="text-muted mb-4">If you have questions about how we handle your data, please contact us.</p>
           <a href="mailto:jawaliholidays@gmail.com" className="btn btn-outline-danger px-4 py-2 rounded-pill">
              <FaEnvelope className="me-2"/> Contact Privacy Officer
           </a>
        </Container>
      </section>

      <Footer />
    </div>
  );
}